export default {
  methods: {
    handleErrorResponse(error) {
      if (error.response && error.response.status === 400) {
        for (let errorId in error.response.data.errors) {
          error.response.data.errors[errorId].forEach(error => {
            this.dangerAlert(error)
          })
        }
      } else {
        this.dangerAlert('Something went wrong')
      }
    },
  }
}